export const Position = {
    CENTER: 'center', 
    LEFT: 'left', 
    RIGHT: 'right', 
}
export const PageType = {
    SimplePage: 'SimplePage', 
    SimpleCard: 'SimpleCard',
    Slider: 'Slider',
    SlideShowPage: 'SlideShowPage',
    ColumnsPage: 'ColumnsPage',
    FrontPage:'FrontPage',
}


// WEBPACK FOOTER //
// ./src/types.js